import React from 'react';
import $ from '../../../offline/jquery.min.js';
import classNames from "classnames";

import { 
  Container,
  ChatListContainer,
  ChatListHeader,
  ChatListContent,
  WrapperContainer
} from './components';

import ChatSectionListScreen from './ChatSectionListScreen';
import ChatSection from './ChatSection';
import ConfigService from '../../Services/api/Config';
import ChatStreamContextProvider, { ChatStreamContext } from "../../Context/ChatStreamContext";
import IconBlue from "../Common/Icon/blue";
import Spin from "../Common/Spin";
import Utils from "../../Services/Utils";

class _LeoChatScreen extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showChatList: false,
    };
  }

  componentDidMount() {
    const { configTheme } = this.props;
    ConfigService.updateConfig(configTheme);
    this.initChat();
  }

  componentWillUnmount() {
    const { chatClient } = this.context;
    if (chatClient) {
      chatClient.off('message.new', this.eventMessageNew);
      chatClient.off('notification.message_new', this.eventMessageNew);
      chatClient.off('message.read', this.eventMessageRead);
      chatClient.off('user.watching.start', this.eventUserChanged);
      chatClient.off('user.watching.stop', this.eventUserChanged);
      chatClient.off('channel.deleted', this.eventChannelChanged);
      chatClient.off('channel.updated', this.eventChannelChanged);
      chatClient.disconnect();
    }
  }

  notificationMessage = (event) => {
    const { showNotificationBanner } = this.context;
    if (showNotificationBanner) {
      new Notification(event.user ? event.user.name : '', {
        body: event.message ? event.message.text : '',
        icon : ConfigService.getLogo('logo3'),
      });
      const audio = new Audio('../../../../audio/notify.mp3');
      audio.play();
    }
  };

  eventMessageNew = (event) => {
    const {
      updateChannelMessages,
      chatList,
      currentUser,
      selectedChannelActive,
      updateChannelList,
    } = this.context;
    let active = false;
    const currentUserId = Utils.isObject(currentUser) ? currentUser.id : currentUser;
    if (!event.user || (currentUserId !== event.user.id)) {
      if (!Utils.isEmpty(selectedChannelActive)) {
        selectedChannelActive.map((channel) => {
          if (channel.id === event.channel_id) {
            active = channel.dataChat.messagesUnread === 0;
          }
        });
      }
      if (!active) {
        let numMessages = 0;
        let exist = false;
        let chat = null;
        chatList.map(({data}) => {
          data.map((channel) => {
            if (channel.id === event.channel_id) {
              exist = true;
              numMessages = channel.dataChat.messagesUnread + 1;
              chat = channel;
            }
          });
        });
        if (!exist) {
          updateChannelList(event.channel_id);
        } else {
          updateChannelMessages(event.channel_id, numMessages);
        }
        if (!chat || !chat.muteStatus().muted) {
          this.notificationMessage(event);
        }
      }
    }
  };

  eventMessageRead = (event) => {
    const {
      updateChannelMessages,
      chatList,
      currentUser,
      selectedChannelActive,
    } = this.context;
    let active = false;
    const currentUserId = Utils.isObject(currentUser) ? currentUser.id : currentUser;
    if (currentUserId === event.user.id) {
      if (!Utils.isEmpty(selectedChannelActive)) {
        selectedChannelActive.map((channel) => {
          if (channel.id === event.channel_id) {
            active = channel.dataChat.messagesUnread === 0;
          }
        });
      }
      if (!active && chatList && !Utils.isEmpty(selectedChannelActive)) {
        updateChannelMessages(event.channel_id, 0);
      }
    }

  };

  eventUserChanged = async (event) => {
    const {
      chatList,
      updateChannelList,
      currentUser,
      checkChannelCustom,
    } = this.context;
    const currentUserId = Utils.isObject(currentUser) ? currentUser.id : currentUser;
    if (chatList && (currentUserId !== event.user.id)) {
      chatList.map(async ({data}) => {
        data.map(async (channel) => {
          if ((channel.id === event.channel_id) && checkChannelCustom(channel) &&
            (channel.state.members[event.user.id] && (channel.state.members[event.user.id].user.online !== event.user.online))) {
            updateChannelList(event.channel_id);
          }
        });
      });
    }
  }

  eventChannelChanged = async (event) => {
    const {
      updateChannelList,
    } = this.context;
    updateChannelList();
  }

  initChat = async () => {
    const {
      chatToken,
      apiKey,
      currentAccountUser,
      accounts
    } = this.props;

    await this.context.setUser(chatToken, apiKey, currentAccountUser, accounts);
    const { chatClient } = this.context;
    if (chatClient) {
      chatClient.on('message.new', this.eventMessageNew);
      chatClient.on('notification.message_new', this.eventMessageNew);
      chatClient.on('message.read', this.eventMessageRead);
      chatClient.on('user.watching.start', this.eventUserChanged);
      chatClient.on('user.watching.stop', this.eventUserChanged);
      chatClient.on('channel.deleted', this.eventChannelChanged);
      chatClient.on('channel.updated', this.eventChannelChanged);
    }
  }

  handleClickChat = () => {
    const { showChatList } = this.state;
    this.setState({
      showChatList: !showChatList
    });
  };

  compressChat = () => {
    const {
      selectedChannel,
      onRemoveSelectChat,
      selectedChannelActive,
      onRemoveChatActive,
      lastChannel
    } = this.context;
    if (selectedChannelActive.length > 1) {
      let indexActive = 0;
      if (selectedChannelActive[indexActive].id === lastChannel.id) {
        indexActive++;
      }
      onRemoveChatActive(selectedChannelActive[indexActive]);
    }
    else if (selectedChannel.length > 1) {
      let index = selectedChannel.length - 1;
      if (selectedChannel[index].id === lastChannel.id) {
        index--;
      }
      onRemoveSelectChat(selectedChannel[index]);
    }
  };

  checkWidthExcess = () => {
    const {
      selectedChannel,
      selectedChannelActive,
      selectedChannelExpand,
    } = this.context;
    let contentWidth = $('.wrapper-columns-column.region-main').width();
    const channelsSelected = selectedChannel ? selectedChannel.length : 0;
    const channelsSelectedActive = selectedChannelActive ? selectedChannelActive.length : 0;
    const channelsSelectedExpand = selectedChannelExpand ? selectedChannelExpand.length : 0;
    let selectedChannelCompress = channelsSelected - channelsSelectedActive - channelsSelectedExpand;
    let chatWidth = (channelsSelectedActive * 320) + (channelsSelectedExpand * 520) + (selectedChannelCompress * 220) + 253;
    if (chatWidth > contentWidth) {
      this.compressChat();
    }
  };

  renderChat = () => {
    const { 
      chatClient, 
      selectedChannel,
      selectedChannelActive,
      selectedChannelExpand,
      onSetMemberList,
      memberList,
      searchRecentList,
      searchUserList,
      currentUser,
    } = this.context;

    if (!selectedChannel) {
      return null;
    }

    setTimeout(this.checkWidthExcess, 0);

    return (
      <>
        { selectedChannel.map( (channel) => (
          <ChatSection
            key={channel.id}
            chatClient={chatClient}
            channel={channel}
            currentUser={currentUser}
            searchUserList={searchUserList}
            searchRecentList={searchRecentList}
            onSetMemberList={onSetMemberList}
            memberList={memberList}
            channelsActive={selectedChannelActive}
            channelsExpand={selectedChannelExpand}
          />
        ))}
      </>
    )
  };
  
  renderChatList = () => {
    const {
      chatList, 
      onSelectChat,
      totalMessagesUnread
    } = this.context;

    const { showChatList } = this.state;

    return (
      <ChatListContainer className='Chat-Element'>
        <ChatListHeader
          onClick={ this.handleClickChat }
          backgroundColor={ ConfigService.getColor('primaryColor') }
        >
          Messenger
          { totalMessagesUnread > 0 &&
            <IconBlue>{totalMessagesUnread}</IconBlue>
          }
        </ChatListHeader>
        <ChatListContent className={ classNames('Chat-List Chat-Element-Slide Chat-Element-Expand', {
            'Chat-Element-Closed': Boolean(!showChatList),
          })}>
          <ChatSectionListScreen
            chatList={chatList}
            onSelectChat={onSelectChat}
          />
        </ChatListContent>
      </ChatListContainer>
    )
  };

  render() {
    const { chatClient, loading } = this.context;

    if (!chatClient) {
      return null;
    }

    return (
      <WrapperContainer>
        <Container>
          {this.renderChat()}
          {this.renderChatList()}
        </Container>
        { loading &&
          <Spin/>
        }
      </WrapperContainer>
    );
  }
}

_LeoChatScreen.contextType = ChatStreamContext;

class LeoChatScreen extends React.Component {
  render() {
    return (
      <ChatStreamContextProvider>
        <_LeoChatScreen {...this.props} />
      </ChatStreamContextProvider>
    );
  }
}

window.LeoChatScreen = LeoChatScreen;
export default LeoChatScreen;
